import _extends from "@babel/runtime/helpers/extends";
import '../../css-tokens';
/* eslint-disable import/order */
import React, { forwardRef } from 'react';
import cx from 'classnames';
// No need for internal system, system enherits from Text
import Text, { SYSTEM_PROPS } from '../Text';
import styles from './index.module.css';
const Heading = /*#__PURE__*/function () {
  const Heading = /*#__PURE__*/forwardRef((_ref, ref) => {
    let {
      as,
      level,
      className,
      ...rest
    } = _ref;
    // Tokens can define a default per heading, per brand.
    const classnames = {
      [styles.heading1Weight]: level === 1 && !rest.fontWeight,
      [styles.heading2Weight]: level === 2 && !rest.fontWeight,
      [styles.heading3Weight]: level === 3 && !rest.fontWeight,
      [styles.heading4Weight]: level === 4 && !rest.fontWeight,
      [styles.heading5Weight]: level === 5 && !rest.fontWeight,
      [styles.heading6Weight]: level === 6 && !rest.fontWeight
    };
    return /*#__PURE__*/React.createElement(Text, _extends({
      className: cx(classnames, className),
      ref: ref,
      as: as || `h${level}`
    }, rest, {
      size: `Heading${level}`
    }));
  });
  Heading.displayName = 'Heading';
  Heading.identifier = Heading.displayName;
  Heading.clonableProps = SYSTEM_PROPS;
  Heading.defaultProps = {
    decoration: 'none',
    fontFamily: 'system',
    level: 1,
    textAlign: 'inherit'
  };
  return Heading;
}();
export default Heading;